module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1523-fa5e77a57d2eaf51dea8172049cc40a6.png";